// extracted by mini-css-extract-plugin
export default {"container":"ConfirmCheckoutDisclaimer_container__uGqsL"};